// CAMINHO: src/App.tsx (VERSÃO ATUALIZADA COM A NOVA ROTA)

import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Clients from "./pages/Clients";
import Cases from "./pages/Cases";
import Tasks from "./pages/Tasks";
import Appointments from "./pages/Appointments";
import Agenda from "./pages/Agenda";
import Documents from "./pages/Documents";
import Financial from "./pages/Financial";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import AICenter from "./pages/AICenter";
import Auth from "./pages/Auth";
import NotFound from "./pages/NotFound";
import TestPage from "./pages/TestPage"; // Importar TestPage
import Layout from "./components/Layout";
import { AuthProvider } from "./contexts/AuthContext";
import { NotificationProvider } from "./contexts/NotificationContext";

import Reports from "./pages/Reports";
import FeeSchedule from "./pages/FeeSchedule";
import Contacts from "./pages/Contacts";
import ProBonoReport from "./pages/ProBonoReport";
import LegalTools from "./pages/LegalTools";
import UserApprovals from "./pages/UserApprovals";
import Notifications from "./pages/Notifications";
import Intimacoes from "./pages/Intimacoes";

// ✅ 1. IMPORTANDO A NOVA PÁGINA DE DETALHES
import { CaseDetailPage } from "./pages/CaseDetailPage"; 
import { ArchivedCases } from "./pages/ArchivedCases";
import AdministrativeProcessDetailPage from "./pages/AdministrativeProcessDetailPage";
import { SignatureFormSimple } from "./components/signature/SignatureFormSimple";
import { DocumentVerification } from "./components/signature/DocumentVerification";
import { EmailConfirmationSimple } from "./components/signature/EmailConfirmationSimple";
import { birthdayNotificationService, setInternalNotificationHandler } from "./services/birthdayNotificationService";
import { PWAInstallPrompt } from "./components/PWAInstallPrompt";
import NotificationHandler from "./components/NotificationHandler";
// Imports antigos do mobile-pwa removidos

const queryClient = new QueryClient();

const App = () => {
  // Inicializa o serviço de notificações de aniversário
  React.useEffect(() => {
    // Solicita permissão para notificações
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  return (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <PWAInstallPrompt />
      {/* MobileRedirect removido junto com o antigo mobile-pwa */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <NotificationProvider>
            <NotificationHandler />
          <Routes>
            <Route path="/" element={<Layout><Index /></Layout>} />
            <Route path="/clients" element={<Layout><Clients /></Layout>} />
            <Route path="/cases" element={<Layout><Cases /></Layout>} />
            <Route path="/archived-cases" element={<Layout><ArchivedCases /></Layout>} />
            <Route path="/reports" element={<Layout><Reports /></Layout>} />
            <Route path="/honorarios" element={<Layout><FeeSchedule /></Layout>} />
            <Route path="/probono-report" element={<Layout><ProBonoReport /></Layout>} />

            {/* ✅ 2. ADICIONANDO A NOVA ROTA PARA A PÁGINA DE DETALHES DO PROCESSO */}
            <Route path="/processo/:id" element={<Layout><CaseDetailPage /></Layout>} />
            <Route path="/administrative-process/:id" element={<Layout><AdministrativeProcessDetailPage /></Layout>} />

            <Route path="/tasks" element={<Layout><Tasks /></Layout>} />
            <Route path="/appointments" element={<Layout><Appointments /></Layout>} />
            <Route path="/agenda" element={<Layout><Agenda /></Layout>} />
            <Route path="/calendar" element={<Layout><Agenda /></Layout>} />
            <Route path="/documents" element={<Layout><Documents /></Layout>} />
            <Route path="/financial" element={<Layout><Financial /></Layout>} />
            <Route path="/legal-tools" element={<Layout><LegalTools /></Layout>} />
            <Route path="/ai-center" element={<Layout><AICenter /></Layout>} />
            <Route path="/profile" element={<Layout><Profile /></Layout>} />
            <Route path="/settings" element={<Layout><Settings /></Layout>} />
            <Route path="/contacts" element={<Layout><Contacts /></Layout>} />
            <Route path="/notifications" element={<Layout><Notifications /></Layout>} />
            <Route path="/intimacoes" element={<Layout><Intimacoes /></Layout>} />
            <Route path="/admin/users" element={<Layout><UserApprovals /></Layout>} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/test" element={<Layout><TestPage /></Layout>} /> {/* Nova rota para a página de testes */}
            
            {/* Rotas do Sistema de Assinatura Eletrônica */}
            <Route path="/assinar/:token" element={<SignatureFormSimple />} />
            <Route path="/verificar/:token" element={<DocumentVerification />} />
            <Route path="/confirmar/:token" element={<EmailConfirmationSimple />} />
            
            {/* Rotas mobile antigas removidas; nova PWA usa /pwa.html e src/pwa/* */}
            
            <Route path="*" element={<NotFound />} />
          </Routes>
          </NotificationProvider>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
  );
};

export default App;